// JOBE-0106: ProjectHeader — composes the three header lanes into the
// horizontal 3-column card per Decision 6 of the spec (wireframe
// Screen B §"Project facts triple").

import React from 'react';
import { PeopleLane } from './PeopleLane.jsx';
import { DepartmentLane } from './DepartmentLane.jsx';
import { RecentActivityLane } from './RecentActivityLane.jsx';

export function ProjectHeader({ project, members, counts, onReassign }) {
  return (
    <section
      className="project-header-card"
      aria-label="Project facts"
      data-testid="project-header"
    >
      <div className="project-header-lane">
        <PeopleLane members={members} onReassign={onReassign} />
      </div>
      <div className="project-header-divider" aria-hidden="true" />
      <div className="project-header-lane">
        <DepartmentLane project={project} counts={counts} />
      </div>
      <div className="project-header-divider" aria-hidden="true" />
      <div className="project-header-lane">
        <RecentActivityLane />
      </div>
    </section>
  );
}
